import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import DestinationInput from "../../../components/Destination/DestinationInput";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import {
  getDestinationDataById
} from "../../../utils/ApiCalls/Destination";

const EditDestination = () => {
  const params = useParams();
  const [destination, setDestination] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Destination List",
      route: "/website/cms/homepage/destinations",
    },
    {
      title: "Edit Destination",
      route: "/website/cms/homepage/destinations/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (id) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getDestinationDataById(id);
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else setDestination(data);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"destinations"}>
      <CustomHeaderTitle title={"Edit Destination"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Destination"}
      ></HeaderBread>
      {destination && <DestinationInput destination={destination} />}
    </Layout>
  );
};

export default EditDestination;
